module.exports = __webpack_public_path__ + "img/66.bb0fc440.jpg";